define('v3/Common/Components/AbilityPercentileBar/AbilityPercentileBar.Component',[
	'knockout',
	'lodash',
	'v3/Common/Services/boundaryPercentileService',
	'v3/Common/Models/enums',
	'env',
	'text!v3/Common/Components/AbilityPercentileBar/AbilityPercentileBar.Component.html',
	'v3/Common/Bindings/SvgIcon.Binding'
], function (ko, _, boundaryPercentileService, enums, env, html) {
	function validateParams (params) {
		if (params.state == null) {
			throw new Error('params.state is required.');
		}
	}

	function AbilityPercentileBar (params) {
		var self = this;

		validateParams(params);

		self.enums = enums;

		self.env = env;

		self.abilityPercentile = ko.pureComputed(function () {
			var abilityPercentile = ko.unwrap(params.abilityPercentile);

			if (abilityPercentile != null && (!_.isNumber(abilityPercentile) || !(abilityPercentile >= 0 && abilityPercentile <= 100))) {
				throw new Error('params.abilityPercentile should be a number between 0 and 100, or null');
			}
			return abilityPercentile;
		});

		self.targetAbilityPercentile = ko.pureComputed(function () {
			var targetAbilityPercentile = ko.unwrap(params.targetAbilityPercentile);

			if (
				targetAbilityPercentile != null &&
				(!_.isNumber(targetAbilityPercentile) || !(targetAbilityPercentile >= 0 && targetAbilityPercentile <= 100))
			) {
				throw new Error('params.targetAbilityPercentile should be a number between 0 and 100, or null');
			}

			return targetAbilityPercentile;
		});

		self.hasTargetAbility = ko.pureComputed(function () {
			return _.isNumber(self.targetAbilityPercentile());
		});

		self.isPreliminary = ko.pureComputed(function () {
			return ko.unwrap(params.state) === enums.abilityPercentileState.preliminary;
		});

		self.isNotStarted = ko.pureComputed(function () {
			return ko.unwrap(params.state) === enums.abilityPercentileState.notStarted;
		});

		self.abilityNumeral = ko.pureComputed(function () {
			var abilityPercentile = self.abilityPercentile();
			var legend = boundaryPercentileService.getLegendTypeByPercentile(abilityPercentile);

			return legend != null ? legend.legendNumeral : null;
		});

		self.abilityDescription = ko.pureComputed(function () {
			if (self.isNotStarted()) {
				return null;
			} else {
				var abilityPercentile = self.abilityPercentile();
				if (abilityPercentile == null) {
					return Strings.ScoreIsNotAvailable;
				}
				var legend = boundaryPercentileService.getLegendTypeByPercentile(abilityPercentile);
				return ' - ' + legend.name + ' (' + abilityPercentile + '%)';
			}
		});

		self.abilityDescriptionMedium = ko.pureComputed(function () {
			if (self.isNotStarted()) {
				return null;
			} else {
				var abilityPercentile = self.abilityPercentile();
				if (abilityPercentile == null) {
					return Strings.ScoreIsNotAvailable;
				}
				var legend = boundaryPercentileService.getLegendTypeByPercentile(abilityPercentile);
				return ' - ' + legend.name;
			}
		});

		self.abilityDescriptionShort = ko.pureComputed(function () {
			if (self.isNotStarted()) {
				return null;
			} else if (self.abilityPercentile() == null) {
				return Strings.ScoreIsNotAvailable;
			} else {
				return ' - (' + self.abilityPercentile() + '%)';
			}
		});

		self.abilityRating = ko.pureComputed(function () {
			if (self.isNotStarted()) {
				return null;
			} else {
				var abilityPercentile = self.abilityPercentile();
				var legend = boundaryPercentileService.getLegendTypeByPercentile(abilityPercentile);

				return legend == null ? null : legend.legendType;
			}
		});
		// END ABILITY BAR V3/V4

		// NEW ABILITY BAR V4.1
		self.newTargetAbilityPercentile = ko.pureComputed(function () {
			var percentile = ko.unwrap(params.targetAbilityPercentile);

			// Get the total percentile that is shown in levels
			// e.g. level 3 = 60% total
			var totalPercentile = self.newMaximumLevel() * 20;

			// Divide current percentile with total percentile
			// e.g. 60 / 80 = 0.75 (which is 75%)
			var position = percentile / totalPercentile * 100;

			return position + '%';
		});

		self.newAbilityPercentile = function (currentLevel) {
			return ko.dependentObservable(function () {
				var percentile = ko.unwrap(params.abilityPercentile);
				var levelPercentile = 0;
				var percentileInLevel = 0;

				if (percentile === null) {
					return 0;
				}

				if (self.isPreliminary() || self.isNotStarted()) {
					return ko.unwrap(params.confidencePercentage) + '%';
				}

				// Define the amount of percentile for each bar
				var percentilePerLevel = 20;

				// If the percentile fits within the current range of the generated level
				// then we are going to calculate the width within that level
				if (percentile < (percentilePerLevel * currentLevel)) {
					// Calculate the percentile within the level
					// e.g. 75 - (20 * 3) = 15
					percentileInLevel = percentile - (percentilePerLevel * (currentLevel - 1));

					if (percentileInLevel <= 0) {
						levelPercentile = 0;
					} else {
						// Get the width within the level
						// e.g. 15 / 20 = 0.75 (which is 75%)
						levelPercentile = percentileInLevel / percentilePerLevel * 100;
					}

				// If percentile is bigger than current level then fill the level to 100%
				} else {
					levelPercentile = 100;
				}

				return levelPercentile + '%';
			});
		};

		var getLevel = function (percentile) {
			if (self.isPreliminary() || self.isNotStarted() || percentile === null) {
				return 0;
			}

			return Math.min((Math.floor(percentile / 20) + 1), 5);
		};

		self.newMaximumLevel = ko.pureComputed(function () {
			var newInputAbilityPercentile = ko.unwrap(params.abilityPercentile);
			var newInputTargetAbilityPercentile = ko.unwrap(params.targetAbilityPercentile);
			var percentile = _.max([newInputAbilityPercentile, newInputTargetAbilityPercentile]);

			return getLevel(percentile);
		});

		self.newCurrentLevel = ko.pureComputed(function () {
			return getLevel(ko.unwrap(params.abilityPercentile));
		});
	}

	return { viewModel: AbilityPercentileBar, template: html };
});

